export interface SessionRecord {
  date: number;
  minutes: number;
}

/**
 * Returns the total minutes from all records that fall on "yesterday"
 * relative to `now` (defaults to the current time).
 */
export const getYesterdayMinutes = (
  records: SessionRecord[],
  now: Date = new Date(),
): number => {
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  return records
    .filter((r) => new Date(r.date).toDateString() === yesterday.toDateString())
    .reduce((sum, r) => sum + r.minutes, 0);
};

/**
 * Calculates the percentage change from yesterday to today.
 * Returns null if yesterday was 0 (to avoid division by zero).
 * e.g. calcPercentageChange(30, 20) → 50  (i.e. +50%)
 */
export const calcPercentageChange = (
  today: number,
  yesterday: number,
): number | null => {
  if (yesterday === 0) return null;
  return Math.round(((today - yesterday) / yesterday) * 100);
};

/**
 * Returns the sum of all minutes across all records.
 */
export const getAllTimeMinutes = (records: SessionRecord[]): number =>
  records.reduce((s, r) => s + r.minutes, 0);
